import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from 'src/app/shared/services/http.service';
import { DeleteWarningComponent } from '../../delete-warning/delete-warning.component';
import { AppService } from 'src/app/app.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import * as XLSX from 'xlsx';
import { ExcelToTableComponent } from '../../excel-to-table/excel-to-table.component';

@Component({
  selector: 'app-ltl-matrix',
  standalone: false,
  templateUrl: './ltl-matrix.component.html',
  styleUrl: './ltl-matrix.component.scss',
})
export class LtlMatrixComponent implements AfterViewInit, OnChanges {
  // dataSource = [
  //   {from:"0", to: "50", '0-50':0, "50-100":50, "100-150":50, "150-200":50, "200-250":10, "250-300":510, "300-350":250, "350-400":350, "400-450":50},
  //   {from:"51", to: "100", '0-50':0, "50-100":100, "100-150":100, "150-200":100, "200-250":100, "250-300":100, "300-350":100, "350-400":100, "400-450":100},
  //   {from:"101", to: "150", '0-50':150, "50-100":150, "100-150":150, "150-200":150, "200-250":150, "250-300":150, "300-350":150, "350-400":150, "400-450":150},
  //   {from:"151", to: "200", '0-50':300, "50-100":300, "100-150":300, "150-200":300, "200-250":300, "250-300":300, "300-350":300, "350-400":300, "400-450":300},
  //   {from:"201", to: "300", '0-50':400, "50-100":450, "100-150":450, "150-200":450, "200-250":450, "250-300":450, "300-350":450, "350-400":450, "400-450":450},
  //   {from:"301", to: "400", '0-50':0, "50-100":100, "100-150":100, "150-200":100, "200-250":100, "250-300":100, "300-350":100, "350-400":100, "400-450":100},
  //   {from:"401", to: "500", '0-50':150, "50-100":150, "100-150":150, "150-200":150, "200-250":150, "250-300":150, "300-350":150, "350-400":150, "400-450":150},
  //   {from:"501", to: "750", '0-50':300, "50-100":300, "100-150":300, "150-200":300, "200-250":300, "250-300":300, "300-350":300, "350-400":300, "400-450":300},
  //   {from:"751", to: "1000", '0-50':400, "50-100":450, "100-150":450, "150-200":450, "200-250":450, "250-300":450, "300-350":450, "350-400":450, "400-450":450},
  //   {from:"1001", to: "1250", '0-50':0, "50-100":100, "100-150":100, "150-200":100, "200-250":100, "250-300":100, "300-350":100, "350-400":100, "400-450":100},
  //   {from:"1251", to: "1500", '0-50':150, "50-100":150, "100-150":150, "150-200":150, "200-250":150, "250-300":150, "300-350":150, "350-400":150, "400-450":150},
  //   {from:"1501", to: "1750", '0-50':300, "50-100":300, "100-150":300, "150-200":300, "200-250":300, "250-300":300, "300-350":300, "350-400":300, "400-450":300},
  //   {from:"1751", to: "2000", '0-50':400, "50-100":450, "100-150":450, "150-200":450, "200-250":450, "250-300":450, "300-350":450, "350-400":450, "400-450":450},
  //   {from:"2001", to: "-", '0-50':400, "50-100":450, "100-150":450, "150-200":450, "200-250":450, "250-300":450, "300-350":450, "350-400":450, "400-450":450},

  // ]
  displayedCol = [
    'from',
    'to',
    '0-50',
    '50-100',
    '100-150',
    '150-200',
    '200-250',
    '250-300',
    '300-350',
    '350-400',
    '400-450',
  ];
  destinCol: string[] = [];
  dbDataSource: any;
  userData: any;

  @Input() rateId: number = 0;
  @Input() name: string = 'ltl Table';
  @Input() orderId: number = 0;
  @Input() operation: string = 'add';
  rateRatio: any;

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog,
    public appService: AppService,
    private tableService: TableService
  ) {
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.appService.matrixDataEmit.subscribe((evt: any) => {
      if (evt.type == 44) {
        this.rateId = evt.id;
        this.getTableData();
      }
    });
    this.appService.ltlRateChangeSub?.unsubscribe();
    this.appService.ltlRateChangeSub =
      this.appService.applyCahngeEmitForLTL.subscribe((evt: any) => {
        if (
          this.appService.rateTableList[this.appService.selectedItem]
            ?.RateTableTypeID === 44
        ) {
          this.rateRatio = evt;
          this.onCalculateRatio();
        }
      });
  }

  toCalculateDeleteArra() {
    this.destinCol = [];
    this.displayedCol.forEach((col) => {
      if (['from', 'to'].includes(col)) {
        if (!this.destinCol.includes('Distance'))
          this.destinCol.push('Distance');
      } else {
        this.destinCol.push(col + '@del');
      }
    });
  }

  ngAfterViewInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']?.currentValue) {
      this.name = changes['name'].currentValue;
    }
    if (changes['orderId']?.currentValue) {
      this.orderId = changes['orderId'].currentValue;
    }
    if (changes['operation']?.currentValue) {
      this.operation = changes['operation'].currentValue;
    }
    if (changes['rateId']?.currentValue) {
      this.rateId = changes['rateId'].currentValue;
    }
    this.destinCol = [];
    this.displayedCol = [];
    this.getTableData();
  }

  getColspan(i: any) {
    if (i != 'Distance') return 1;
    return 2;
  }

  formatElementData(val: any) {
    return val != null ? '' + Number(val).toFixed(2) : '';
  }

  getTableData() {
    if (this.appService.rateBackUpData[this.appService.selectedItem]) {
      let res = this.appService.rateBackUpData[this.appService.selectedItem];
      let keys = Object.keys(res[0]);
      this.displayedCol = keys; //['from','to', ...uniqueWeights];
      this.toCalculateDeleteArra();
      this.dbDataSource = res;
      this.appService.exportConversionEmitter.emit({
        data: this.dbDataSource,
        type: 'ltl',
      });
      return;
    }

    this.appService.isLoading = true;
    this.httpService.getLTLTable(this.rateId).subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        const uniqueWeights: any = [
          ...new Set(res.map((obj: any) => obj.Weight)),
        ];
        // console.log("unique",uniqueWeights);
        // const updateRanges = uniqueWeights.map((value:any) => {
        //   // Check if the value doesn't contain a "-" and is not "from" or "to"
        //   if (!value.includes("-") && value !== "from" && value !== "to") {
        //       return `${value}-+`;  // Append "-+" to the value
        //   }
        //   return value;  // Return the original value if it already has "-" or is "from/to"
        // });

        this.displayedCol = ['from', 'to', ...uniqueWeights];
        this.toCalculateDeleteArra();
        const updatedArray = res.map((obj: any) => {
          const { Weight, Cost, ...rest } = obj;
          return { LTLWeight: Weight, LTLCost: Cost, ...rest };
        });

        this.appService.setRateTableData(updatedArray, this.orderId, 'ltl');
        const transformedArray = res.map((obj: any) => {
          const weightRange = obj.Weight.split('-');
          const distanceRange = obj.Distance.split('-');

          return {
            from: distanceRange[0],
            to: distanceRange[1],
            [weightRange.join('-')]: obj.Cost,
          };
        });

        const finalArray = Object.values(
          transformedArray.reduce((acc: any, obj: any) => {
            const key = `${obj.from}-${obj.to}`;
            if (!acc[key]) {
              acc[key] = {
                from: obj.from,
                to: obj.to,
              };
            }
            Object.assign(acc[key], obj);
            return acc;
          }, {})
        );

        this.dbDataSource = finalArray.sort(
          (a: any, b: any) => Number(a.from) - Number(b.from)
        );
        let orderkeys = this.displayedCol.sort((a, b) => {
          const isANumber = !isNaN(parseInt(a));
          const isBNumber = !isNaN(parseInt(b));

          if (isANumber && isBNumber) {
            return parseInt(a) - parseInt(b);
          } else if (isANumber) {
            return -1;
          } else if (isBNumber) {
            return 1;
          } else {
            return a.localeCompare(b);
          }
        });

        // const output = result.map((obj:any) => {
        //   const updatedObj:any = {};
        //   for (const key in obj) {
        //     if (!key.includes("-") && (key != 'from') && (key != 'to')) {
        //       updatedObj[key + "-+"] = obj[key];
        //     } else {
        //       updatedObj[key] = obj[key];
        //     }
        //   }
        //   return updatedObj;
        // });

        this.displayedCol = orderkeys.filter(
          (item) => !['from', 'to'].includes(item)
        );
        this.displayedCol = ['from', 'to', ...this.displayedCol];

        let obj = {
          data: this.dbDataSource,
          type: 'ltl',
          maut: [],
          charge: [],
        };

        this.appService.rateBackUpData[this.appService.selectedItem] =
          this.dbDataSource;
        // this.appService.exportPDFTableList[this.appService.selectedItem] = obj
        this.appService.exportConversionEmitter.emit({
          data: this.dbDataSource,
          type: 'ltl',
        });
      }
    });
  }

  onCalculateRatio() {
    this.appService.onRAvalueChanged = true;
    let truckList = Object.keys(this.dbDataSource[0]);
    truckList = truckList.filter((item: any) => !['from', 'to'].includes(item));
    this.dbDataSource.forEach((obj: any) => {
      truckList.forEach((i: any) => {
        let item = Number(obj[i]);
        if (obj[i] !== null) {
          obj[i] =
            obj[i] === 0
              ? 0
              : +(item + Number(item * (this.rateRatio / 100))).toFixed(2);
        }
      });
    });
    this.onSave('all', 'all', 0);
  }

  onExportdata() {
    // let arr = [{displayName:"Km Band Min", name:'from' ,order : 1},{displayName:"Km Band Max", name:'to' ,order : 2}]
    // this.destinCol.filter((item:any) => item.includes("@del"))
    // .map((item:any) =>{
    //   let str = item.split("@del")[0];
    //   let count = arr.length;
    //   arr.push({displayName:`${str}`, name:`${str}`,order : count+1})
    // } );
    let arr = [
      {
        displayName: 'Km Band Min',
        name: 'from',
        order: 1,
      },
      {
        displayName: 'Km Band Max',
        name: 'to',
        order: 2,
      },
      {
        displayName: '100-200',
        name: '100-200',
        order: 3,
      },
      {
        displayName: '201-300',
        name: '201-300',
        order: 4,
      },
      {
        displayName: '301-400',
        name: '301-400',
        order: 5,
      },
      {
        displayName: '401-500',
        name: '401-500',
        order: 6,
      },
      {
        displayName: '501-750',
        name: '501-750',
        order: 7,
      },
      {
        displayName: '751-1000',
        name: '751-1000',
        order: 8,
      },
      {
        displayName: '1001-1250',
        name: '1001-1250',
        order: 9,
      },
      {
        displayName: '1251-1500',
        name: '1251-1500',
        order: 10,
      },
      {
        displayName: '1501-1750',
        name: '1501-1750',
        order: 11,
      },
      {
        displayName: '1751-2000',
        name: '1751-2000',
        order: 12,
      },
      {
        displayName: '2001-2500',
        name: '2001-2500',
        order: 13,
      },
      {
        displayName: '2501-3000',
        name: '2501-3000',
        order: 14,
      },
      {
        displayName: '3001-3500',
        name: '3001-3500',
        order: 15,
      },
      {
        displayName: '3501-4000',
        name: '3501-4000',
        order: 16,
      },
      {
        displayName: '4001-5000',
        name: '4001-5000',
        order: 17,
      },
      {
        displayName: '5001-6000',
        name: '5001-6000',
        order: 18,
      },
      {
        displayName: '6001-7000',
        name: '6001-7000',
        order: 19,
      },
      {
        displayName: '7001-8000',
        name: '7001-8000',
        order: 20,
      },
      {
        displayName: '8001-9000',
        name: '8001-9000',
        order: 21,
      },
      {
        displayName: '9001-10000',
        name: '9001-10000',
        order: 22,
      },
      {
        displayName: '10001-12500',
        name: '10001-12500',
        order: 23,
      },
      {
        displayName: '12501-15000',
        name: '12501-15000',
        order: 24,
      },
      {
        displayName: '15001-20000',
        name: '15001-20000',
        order: 25,
      },
      {
        displayName: '20001-23999',
        name: '20001-23999',
        order: 26,
      },
      {
        displayName: '24000-+',
        name: '24000-+',
        order: 27,
      },
    ];
    this.tableService.exportToExcel(this.dbDataSource, arr, this.name);
  }
  onSave(val: any, e: string, no: number) {
    let getData = sessionStorage.getItem('user-data');
    let userData = getData ? JSON.parse(getData) : null;
    let transformedArray = this.dbDataSource.flatMap((obj: any) => {
      const { from, to, ...weights } = obj;
      return Object.entries(weights).map(([weightRange, cost]) => ({
        Distance: `${from}-${to}`,
        LTLWeight: weightRange,
        LTLCost: cost,
      }));
    });

    this.appService.setRateTableData(transformedArray, this.orderId, 'ltl');
  }
  onImportData() {
    const dialogRef = this.dialog.open(ExcelToTableComponent, {
      disableClose: false,
      data: { screen: 'ltl' },
    });
    dialogRef.afterClosed().subscribe((evt) => {
      if (evt.operation === 'save' && evt.type === 'ltl') {
        this.appService.onRAvalueChanged = true;
        this.displayedCol = [];
        this.destinCol = [];
        const result = evt.data.reduce((acc: any, item: any) => {
          const { from, to, ...rest } = item;
          const entry = acc.find(
            (entry: any) => entry.from === from && entry.to === to
          );
          if (entry) {
            // if(rest.split("-")[1])
            Object.assign(entry, rest);
          } else {
            acc.push({ from, to, ...rest });
          }
          return acc;
        }, []);

        const output = result.map((obj: any) => {
          const updatedObj: any = {};
          for (const key in obj) {
            if (!key.includes('-') && key != 'from' && key != 'to') {
              updatedObj[key + '-+'] = obj[key];
            } else {
              updatedObj[key] = obj[key];
            }
          }
          return updatedObj;
        });
        this.dbDataSource = output;

        this.toChangeForDb();
        this.appService.rateBackUpData[this.appService.selectedItem] =
          this.dbDataSource;
        let keys = Object.keys(this.dbDataSource[0]).filter(
          (item) => !['from', 'to'].includes(item)
        );
        // this.appService.exportConversionEmitter.emit({data:this.dbDataSource, type:'ltl'})
        keys.sort((a, b) => {
          let numA = parseInt(a.split('-')[0]);
          let numB = parseInt(b.split('-')[0]);
          return numA - numB;
        });
        this.displayedCol = ['from', 'to', ...keys];
      }
    });
  }
  onAddTrailer() {
    this.appService.onRAvalueChanged = true;
    if (this.displayedCol.includes('add')) {
      this.httpService.openSnackBar('Please Fill the Empty Trailer Value');
      return;
    }
    this.displayedCol.push('add');
    this.destinCol.push('add@del');
    this.dbDataSource = this.dbDataSource.map((item: any) => ({
      ...item,
      add: 0,
    }));
    this.dbDataSource = [...this.dbDataSource];
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.toChangeForDb();
  }

  onColumChange(e: any, name: string) {
    this.appService.onRAvalueChanged = true;
    const updatedDataSource = this.dbDataSource.map((item: any) => {
      const updatedItem: any = {};
      for (const key in item) {
        if (key === name) {
          updatedItem[e.value] = item[key];
        } else {
          updatedItem[key] = item[key];
        }
      }
      return updatedItem;
    });
    const updatedArray = this.displayedCol.map((item) => {
      if (item === name) {
        return e.value;
      }
      return item;
    });
    this.displayedCol = [...updatedArray];
    this.dbDataSource = [...updatedDataSource];
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.dbDataSource = this.dbDataSource.map((obj: any) => {
      if (obj.hasOwnProperty(name)) {
        obj[e.value] = obj[name];
        delete obj[name];
      }
      return obj;
    });

    let keys = Object.keys(this.dbDataSource[0]).filter(
      (item) => !['from', 'to'].includes(item)
    );

    keys.sort((a, b) => {
      let numA = parseInt(a.split('-')[0]);
      let numB = parseInt(b.split('-')[0]);
      return numA - numB;
    });
    this.displayedCol = ['from', 'to', ...keys];
    this.destinCol = [];
    this.toCalculateDeleteArra();
    this.toChangeForDb();
  }

  onValueCahnge(val: any, e: string, no: number) {
    this.appService.onRAvalueChanged = true;
    let cost: number = val.value;
    this.dbDataSource[no][e] = Number(cost);
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.onSave(val, e, no);
  }

  onDeleteTrailer(i: any) {
    this.appService.onRAvalueChanged = true;
    let val: string = i.split('@')[0];
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: {
        header: 'Delete LTL Trailer',
        msg: `Are you sure you want to delete the LTL Trailer?`,
      },
    });
    dialogRef.afterClosed().subscribe((evt: any) => {
      if (evt.operation === 'confirm') {
        let updatedData: any = this.dbDataSource.map((item: any) => {
          const { [val as string]: _, ...rest }: { [key: string]: any } = item;
          return rest;
        });
        this.dbDataSource = [...updatedData];
        this.appService.rateBackUpData[this.appService.selectedItem] =
          this.dbDataSource;
        this.displayedCol = this.displayedCol.filter(
          (item) => !item.includes(val)
        );
        this.destinCol = this.destinCol.filter((item) => !item.includes(val));
        this.toChangeForDb();
      }
    });
  }

  toChangeForDb() {
    const transformedArray = this.dbDataSource.flatMap((item: any) => {
      const { from, to, ...rest } = item;
      return Object.entries(rest).map(([LTLWeight, LTLCost]) => ({
        Distance: `${from}-${to}`,
        LTLCost,
        LTLWeight,
      }));
    });
    let keys = Object.keys(this.dbDataSource[0]).filter(
      (item) => !['from', 'to'].includes(item)
    );
    let orderkeys = keys.map((i: any) => i + '@del');
    orderkeys.sort((a, b) => {
      const numA = parseInt(a.split('@')[0]);
      const numB = parseInt(b.split('@')[0]);
      return numA - numB;
    });
    this.destinCol = [];
    this.destinCol = ['Distance', ...orderkeys];
    this.appService.setRateTableData(transformedArray, this.orderId, 'ltl');
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'ltl',
    });
  }
}
